import { createSelector } from "reselect";
import { AppState } from "state/store";
const selector = (state: AppState) => state.presurvey;

export default createSelector([selector], (data) => data);